export const actionTypes = {
  GET_YOUTUBE_LIST_PENDING: "GET_YOUTUBE_LIST_PENDING",
  GET_YOUTUBE_LIST_SUCCESS: "GET_YOUTUBE_LIST_SUCCESS",
  GET_YOUTUBE_LIST_ERROR: "GET_YOUTUBE_LIST_ERROR",

  GET_YOUTUBE_VIDEO_BY_ID_PENDING: "GET_YOUTUBE_VIDEO_BY_ID_PENDING",
  GET_YOUTUBE_VIDEO_BY_ID_SUCCESS: "GET_YOUTUBE_VIDEO_BY_ID_SUCCESS",
  GET_YOUTUBE_VIDEO_BY_ID_ERROR: "GET_YOUTUBE_VIDEO_BY_ID_ERROR",

  ADD_YOUTUBE_PUBLISHED_PENDING: "ADD_YOUTUBE_PUBLISHED_PENDING",
  ADD_YOUTUBE_PUBLISHED_SUCCESS: "ADD_YOUTUBE_PUBLISHED_SUCCESS",
  ADD_YOUTUBE_PUBLISHED_ERROR: "ADD_YOUTUBE_PUBLISHED_ERROR",

  ADD_MULTIPLE_PUBLISH_PENDING: "ADD_MULTIPLE_PUBLISH_PENDING",
  ADD_MULTIPLE_PUBLISH_SUCCESS: "ADD_MULTIPLE_PUBLISH_SUCCESS",
  ADD_MULTIPLE_PUBLISH_ERROR: "ADD_MULTIPLE_PUBLISH_ERROR",

  ADD_YOUTUBE_BY_URL_PENDING: "ADD_YOUTUBE_BY_URL_PENDING",
  ADD_YOUTUBE_BY_URL_SUCCESS: "ADD_YOUTUBE_BY_URL_SUCCESS",
  ADD_YOUTUBE_BY_URL_ERROR: "ADD_YOUTUBE_BY_URL_ERROR",

  UPLOAD_THUMBNAIL_PENDING: "UPLOAD_THUMBNAIL_PENDING",
  UPLOAD_THUMBNAIL_SUCCESS: "UPLOAD_THUMBNAIL_SUCCESS",
  UPLOAD_THUMBNAIL_ERROR: "UPLOAD_THUMBNAIL_ERROR",

  RESET_REDIRECTED_STATE: "RESET_REDIRECTED_STATE",
  RESET_PAGE_AND_LIMIT: "RESET_PAGE_AND_LIMIT",

  SET_SEARCH_FILTERS: "SET_SEARCH_FILTERS",
  RESET_SET_SEARCH_FILTERS: "RESET_SET_SEARCH_FILTERS",

  SET_SEARCH_FILTERS_FOR_VIDEOS_BY_URL: "SET_SEARCH_FILTERS_FOR_VIDEOS_BY_URL",
  RESET_SEARCH_FILTERS_FOR_VIDEOS_BY_URL:
    "RESET_SEARCH_FILTERS_FOR_VIDEOS_BY_URL",

  SET_ACTIVE_NAVIGATION_TAB: "SET_ACTIVE_NAVIGATION_TAB",
  RESET_ACTIVE_NAVIGATION_TAB: "RESET_ACTIVE_NAVIGATION_TAB",

  SET_UPDATED_ROW_TAGS: "SET_UPDATED_ROW_TAGS",
  RESET_UPDATED_ROW_TAGS: "RESET_UPDATED_ROW_TAGS",

  SET_UPDATED_ROW_CATEGORY: "SET_UPDATED_ROW_CATEGORY",
  RESET_UPDATED_ROW_CATEGORY: "RESET_UPDATED_ROW_CATEGORY",

  SET_NAVIGATING_TO_OTHER_PAGE: "SET_NAVIGATING_TO_OTHER_PAGE",
  RESET_NAVIGATING_TO_OTHER_PAGE: "RESET_NAVIGATING_TO_OTHER_PAGE",

  SET_SHOW_SELECTION: "SET_SHOW_SELECTION",
  RESET_SHOW_SELECTION: "RESET_SHOW_SELECTION",

  SET_SELECTED_MULTIPLE_ROWS: "SET_SELECTED_MULTIPLE_ROWS",
  RESET_SELECTED_MULTIPLE_ROWS: "RESET_SELECTED_MULTIPLE_ROWS",
  SET_NAVIGATING_TO_OTHER_TAB: "SET_NAVIGATING_TO_OTHER_TAB",
};

export const youtubeUrlConstants = {
  YOUTUBE_VIDEOS_BY_DAILY_CRON: "videosByDailyCron",
  YOUTUBE_VIDEOS_BY_URL: "videosByUrl",
};

const initialState = {
  getYouTubeListPending: false,
  getYouTubeListSuccess: false,
  getYouTubeListError: null,

  getYouTubeVideoByIdPending: false,
  getYouTubeVideoByIdSuccess: false,
  getYouTubeVideoByIdError: null,

  addYouTubePublishedPending: false,
  addYouTubePublishedSuccess: false,
  addYouTubePublishedError: null,

  addMultiplePublishPending: false,
  addMultiplePublishSuccess: false,
  addMultiplePublishError: null,

  addYoutubeByUrlPending: false,
  addYoutubeByUrlSuccess: false,
  addYoutubeByUrlError: null,

  uploadThumbnailPending: false,
  uploadThumbnailSuccess: false,
  uploadThumbnailError: null,

  youtubeList: [],
  redirected: false,
  currentPage: 1,
  currentLimit: 10,
  currentPageVideoByUrl: 1,
  currentLimitVideoByUrl: 10,
  //this is search values for videosByDailyCorn
  titleSearch: "",
  statusSearch: "",
  languageSearch: "",
  channelSearch: "",
  //this is search values for videosByUrl
  videosByUrlTitleSearch: "",
  videosByUrlStatusSearch: "",
  videosByUrlLanguageSearch: "",
  videosByUrlChannelSearch: "",
  //
  showWarningForRowTagsWhenNavigating: false,
  redirectingLink: "", // when navigating to other page
  redirectingTab: "", //when tab changing
  //
  activeNavTab: youtubeUrlConstants?.YOUTUBE_VIDEOS_BY_DAILY_CRON, //initial active tab
  rowTags: [],
  rowCategory: [],
  showSelection: false,
  selectedMultipleRowVideo: [],
};

export default function youtubeManagement(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case actionTypes.GET_YOUTUBE_LIST_PENDING:
    case actionTypes.GET_YOUTUBE_LIST_SUCCESS:
    case actionTypes.GET_YOUTUBE_LIST_ERROR:
      return Object.assign({}, state, payload);

    case actionTypes.GET_YOUTUBE_VIDEO_BY_ID_PENDING:
    case actionTypes.GET_YOUTUBE_VIDEO_BY_ID_SUCCESS:
    case actionTypes.GET_YOUTUBE_VIDEO_BY_ID_ERROR:
      return Object.assign({}, state, payload);

    case actionTypes.ADD_YOUTUBE_PUBLISHED_PENDING:
    case actionTypes.ADD_YOUTUBE_PUBLISHED_SUCCESS:
    case actionTypes.ADD_YOUTUBE_PUBLISHED_ERROR:
      return Object.assign({}, state, payload);

    case actionTypes.ADD_MULTIPLE_PUBLISH_PENDING:
    case actionTypes.ADD_MULTIPLE_PUBLISH_SUCCESS:
    case actionTypes.ADD_MULTIPLE_PUBLISH_ERROR:
      return Object.assign({}, state, payload);

    case actionTypes.ADD_YOUTUBE_BY_URL_PENDING:
    case actionTypes.ADD_YOUTUBE_BY_URL_SUCCESS:
    case actionTypes.ADD_YOUTUBE_BY_URL_ERROR:
      return Object.assign({}, state, payload);

    case actionTypes.UPLOAD_THUMBNAIL_PENDING:
    case actionTypes.UPLOAD_THUMBNAIL_SUCCESS:
    case actionTypes.UPLOAD_THUMBNAIL_ERROR:
      return Object.assign({}, state, payload);

    case actionTypes.RESET_REDIRECTED_STATE:
      return Object.assign({}, state, payload);

    case actionTypes.RESET_PAGE_AND_LIMIT:
      return Object.assign({}, state, payload);

    case actionTypes.SET_SEARCH_FILTERS:
      return Object.assign({}, state, payload);

    case actionTypes.RESET_SET_SEARCH_FILTERS:
      return Object.assign({}, state, payload);

    case actionTypes.SET_SEARCH_FILTERS_FOR_VIDEOS_BY_URL:
      return Object.assign({}, state, payload);

    case actionTypes.RESET_SEARCH_FILTERS_FOR_VIDEOS_BY_URL:
      return Object.assign({}, state, payload);

    case actionTypes.SET_ACTIVE_NAVIGATION_TAB:
      return Object.assign({}, state, payload);

    case actionTypes.RESET_ACTIVE_NAVIGATION_TAB:
      return Object.assign({}, state, payload);

    case actionTypes.SET_UPDATED_ROW_TAGS:
      return Object.assign({}, state, payload);

    case actionTypes.RESET_UPDATED_ROW_TAGS:
      return Object.assign({}, state, payload);

    case actionTypes.SET_UPDATED_ROW_CATEGORY:
      return Object.assign({}, state, payload);

    case actionTypes.RESET_UPDATED_ROW_CATEGORY:
      return Object.assign({}, state, payload);

    case actionTypes.SET_NAVIGATING_TO_OTHER_PAGE:
      return Object.assign({}, state, payload);

    case actionTypes.RESET_NAVIGATING_TO_OTHER_PAGE:
      return Object.assign({}, state, payload);

    case actionTypes.SET_SHOW_SELECTION:
      return Object.assign({}, state, payload);

    case actionTypes.RESET_SHOW_SELECTION:
      return Object.assign({}, state, payload);

    case actionTypes.SET_SELECTED_MULTIPLE_ROWS:
      return Object.assign({}, state, payload);

    case actionTypes.SET_NAVIGATING_TO_OTHER_TAB:
      return Object.assign({}, state, payload);

    case actionTypes.RESET_SELECTED_MULTIPLE_ROWS:
      return Object.assign({}, state, payload);

    default:
      return state;
  }
}
